import alchemist from "./alchemist.png";
import baker from "./baker.png";
import druid from "./druid.png";
import farmer from "./farmer.png";
import ironMiner from "./iron_miner.png";
import mason from "./mason.png";
import smith from "./smith.png";
import stoneMiner from "./stone_miner.png";
import trader from "./trader.png";
import credit from "./credit.png";

export const businesses: {[keys: string]: any} = {
  alchemist,
  baker,
  druid,
  farmer,
  ironMiner,
  mason,
  smith,
  stoneMiner,
  trader
}

export const icons:{[keys: string]: any} = {
  credit
}
